import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { css } from "styled-components";

/*

**** EC-231 Product Details Page (PDP) ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
addToListLinkStyles.link = {
    link: {
        css: css`
            text-align: right;
            padding-right: 8px;
        `,
    },
};
// EC-617 - [FE] Fix Text overlapping on share icon
addToListLinkStyles.wrapper = {
    css: css`
        text-align: right;
        // EC-617 : Fixing css issues on PLP & PDP
        margin-top: 10px;
        border-right: 1px solid rgb(71, 71, 71);

        [data-test-selector="productDetails_addToList"] {
            padding-left: 8px;
            font-size: 12px; // EC-617 : Fixing css issues on PLP & PDP
        }
        @media screen and (max-width: 768px) {
            border-right: none; // EC-617 : Fixing css issues on PLP & PDP
            display: flex;
            justify-content: center;
            align-items: center;
            [data-test-selector="productDetails_addToList"] {
                text-indent: -9999px;
                background: url("/userfiles/pdp/add-to-list16.svg?width=16&height=16") no-repeat;
                width: 16px;
                height: 16px;
                border: none;
                white-space: nowrap !important;
                span{
                    position: absolute !important;
                    width: 1px !important;
                    height: 1px !important;
                    padding: 0 !important;
                    margin: -1px !important;
                    overflow: hidden !important;
                    clip: rect(0 0 0 0) !important;
                    white-space: nowrap !important;
                    border: 0 !important;
                }
            }
        }
    `,
};
/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS. */
